import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {DashboardComponent} from './dashboard/dashboard.component';
import {RoleGuard} from '@services/role.guard';
import {StatisticResolve} from '@services/statistics.resolve';

const routes: Routes = [
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [RoleGuard],
    data: {expectedRole: '2'},
    resolve: {
      statistics: StatisticResolve
    }
  },
  { path: 'admin',
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent
      },
    ],
    canActivate: [RoleGuard],
    data: {expectedRole: '5'},
    resolve: {
      statistics: StatisticResolve
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dashboard-routing.module.ts